export enum CONTACT_REASONS {
    DEACTIVATE_DEALERSHIP = 'deactivate_dealership',
    DEACTIVATE_ACCOUNT = 'deactivate_account',
    MISSING_VEHICLE_OPTION =  'missing_vehicle_option',
    OTHER = 'other',
    TECHNICAL_ISSUES = 'technical_issues',
}
